import Link from "@components/Link";
import Button from "@components/Button";
import Image from "@components/Image";
import Markdown from "@components/Markdown";
import cx from "classnames";
import styles from "./OverviewAboutUs.module.scss";
import { usePageContext } from "@providers/PageProvider";
import renderPropsComposer from "@utils/renderPropsComposer";
import helper from "@utils/helper";
import _ from "lodash";
const components = {
  p: (props: any) => <p {...props} className={cx(props.className, "mb-4")} />,
};
export default function OverviewAboutUs() {
  const { pageData } = usePageContext();
  const {
    displayType,
    youtubeVideoEmbedLink,
    content,
    readMoreButton,
    aboveImage,
    belowImage,
  } = helper.formatAboutUsData(pageData);
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.content)}>
        <div className={cx(styles.des)}>
          <Markdown components={components} content={content} />
        </div>
        <Link href={_.get(readMoreButton, "href")}>
          <Button
            type="icon"
            suffix="shape-arrow"
            className={cx(styles.moreAboutUsWrapper)}
            label={_.get(readMoreButton, "label")}
            // onClick={() => router.push("brand-story")}
          />
        </Link>
      </div>

      {renderPropsComposer(
        {
          matcher: ({ displayType }: any) => displayType === "video",
          render: () => (
            <div className={styles.videoWrapper}>
              <div className={styles.video}>
                <iframe
                  width="100%"
                  height="100%"
                  src={youtubeVideoEmbedLink}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ),
        },
        {
          matcher: "default",
          render: () => (
            <div className={cx(styles.imagesWrapper)}>
              <div className={cx(styles.image1Wrapper)}>
                <Image
                  scale={1.02}
                  wrapperProps={{ className: cx(styles.image1) }}
                  src={_.get(aboveImage, "src", "")}
                  alt={_.get(aboveImage, "alt", "")}
                  layout="fill"
                  objectFit="cover"
                />
              </div>
              <div className={cx(styles.image2Wrapper)}>
                <Image
                  scale={1.1}
                  wrapperProps={{ className: cx(styles.image2) }}
                  src={_.get(belowImage, "src", "")}
                  alt={_.get(belowImage, "alt", "")}
                  layout="fill"
                  objectFit="cover"
                />
              </div>
            </div>
          ),
        }
      )({ displayType })}
    </div>
  );
}
